import { getHeaders, getMXIEndpoint } from "../../../helpers/endpoint";

export const updateGameWeek = (championshipId, gameWeekNumber, confirm, onSuccess, onError) => {
  return (_dispatch, getState) => {
    fetch(getMXIEndpoint('updateMXIGameWeek', {championshipId, gameWeekNumber, confirm}), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          onError(data);
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {
        onError && onError(error);
      });
  };
};


// WEBPACK FOOTER //
// ./src/actions/entities/mxi/updateGameWeek.js